module.exports = __webpack_public_path__ + "img/17.ba4f3ae3.jpg";